/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeammateHealthAvatar_org = {
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_org">;
    readonly " $refType": "TeammateHealthAvatar_org";
};
export type TeammateHealthAvatar_org$data = TeammateHealthAvatar_org;
export type TeammateHealthAvatar_org$key = {
    readonly " $data"?: TeammateHealthAvatar_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeammateHealthAvatar_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeammateHealthAvatar_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "experiments",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AvatarPerson_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = 'd3fe1c253ed74536cb33216dcfc9f17f';
export default node;
